/**
 * @generated SignedSource<<1f1eea5ee50176b251202d74ed82f23e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type WidgetIntegrationTurnpikeSize = "TWO_X_ONE" | "TWO_X_TWO";
import { FragmentRefs } from "relay-runtime";
export type WidgetIntegrationTurnpike_widgetIntegrationTurnpike$data = {
  readonly id: string;
  readonly integration: {
    readonly summary: {
      readonly " $fragmentSpreads": FragmentRefs<"WidgetIntegrationTurnpikeLarge_integrationTurnpikeSummary" | "WidgetIntegrationTurnpikeSmall_integrationTurnpikeSummary">;
    } | null;
  };
  readonly turnpikeSize: WidgetIntegrationTurnpikeSize;
  readonly " $fragmentType": "WidgetIntegrationTurnpike_widgetIntegrationTurnpike";
};
export type WidgetIntegrationTurnpike_widgetIntegrationTurnpike$key = {
  readonly " $data"?: WidgetIntegrationTurnpike_widgetIntegrationTurnpike$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetIntegrationTurnpike_widgetIntegrationTurnpike">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetIntegrationTurnpike_widgetIntegrationTurnpike",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "turnpikeSize",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IntegrationTurnpike",
      "kind": "LinkedField",
      "name": "integration",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "IntegrationTurnpikeSummary",
          "kind": "LinkedField",
          "name": "summary",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "WidgetIntegrationTurnpikeSmall_integrationTurnpikeSummary"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "WidgetIntegrationTurnpikeLarge_integrationTurnpikeSummary"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetIntegrationTurnpike",
  "abstractKey": null
};

(node as any).hash = "57968730949883ae3b38543e1666a76c";

export default node;
